import { BEST_KEY } from './constants';

export function loadBest(): number {
  try {
    const raw = window.localStorage.getItem(BEST_KEY);
    if (!raw) return 0;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
  } catch {
    return 0;
  }
}

export function saveBest(score: number): number {
  const prev = loadBest();
  const next = Math.max(prev, Math.max(0, Math.floor(score)));
  try {
    window.localStorage.setItem(BEST_KEY, String(next));
  } catch {
    /* private mode */
  }
  return next;
}
